import { FC } from 'react';

import LabelIcon from '@mui/icons-material/Label';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const LabelsCard: FC = () => (
  <ToolCard
    icon={<LabelIcon fontSize="large" />}
    title="Etiketės"
    description="Kelionių etikečių redagavimas"
    action={
      <Button href="labels" startIcon={<LabelIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default LabelsCard;
